export default "__VITE_PUBLIC_ASSET__e0ee5d01__"